<template>
  <b-modal no-close-on-backdrop no-close-on-esc size="md" :id="idModal" :title="titleModal" :ok-title="labelBtnOk"
    ok-variant="success" cancel-variant="secondary" body-bg-variant="light" cancel-title="Cancelar"
    @ok="validateForm(); resetform()" @cancel="$emit('cancel'); resetform()" @close="$emit('cancel')"
    @shown="onModalShow" :ok-disabled="isFormInvalid">
    <validation-observer ref="refFormData" v-slot="{ invalid }">
      <b-form @submit.prevent>
        <b-row>
          <b-col cols="12" class="mb-1">
            <b-form-group label="Tipo Workflow" label-for="workflowid">
              <validation-provider #default="{ errors }" name="Tipo Workflow" rules="required">
                <b-form-select v-model="workflowtipoid" id="workflowtipoid" :state="errors.length > 0 ? false : null"
                  :options="dataFromApiWorkflowTipo" value-field="workflowtipoid" text-field="workflowtipodescricao"
                  placeholder="Selecione uma workflow tipo" @change="fetchDataFromWorkflow()"
                  :disabled="loadingWorkflowTipo">
                  <template #first>
                    <b-form-select-option :value="null" disabled>
                      {{ loadingWorkflowTipo ? 'Carregando...' : 'Selecione uma workflow tipo' }}
                    </b-form-select-option>
                  </template>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-form-group label="Workflow" label-for="workflowid">
              <validation-provider #default="{ errors }" name="Workflow" rules="required">
                <b-form-select v-model="dataForm.workflowid" id="workflowid" :state="errors.length > 0 ? false : null"
                  :options="dataFromApiWorkflow" value-field="workflowid" text-field="workflowdescricao"
                  placeholder="Selecione uma workflow" :disabled="workflowtipoid === null || loadingWorkflow">
                  <template #first>
                    <b-form-select-option :value="null" disabled>
                      {{ loadingWorkflow ? 'Carregando...' : 'Selecione uma workflow' }}
                    </b-form-select-option>
                  </template>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12" class="mb-1">
            <b-form-group label="Funcionario" label-for="funcionarioid">
              <validation-provider #default="{ errors }" name="Funcionário" rules="required">
                <v-select
                  v-model="dataForm.funcionarioid"
                  :options="dataFromApiUsuario"
                  :reduce="user => user.value"
                  label="label"
                  placeholder="Selecione um usuario"
                  :disabled="loadingUsuario"
                  :class="{'is-invalid': errors.length > 0}"
                  id="funcionarioid"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@validations';
import axios from '@/libs/axios';

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        workflowid: '',
        funcionarioid: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  data() {
    return {
      dataFromApiWorkflow: null,
      dataFromApiUsuario: null,
      dataFromApiWorkflowTipo: null,
      workflowtipoid: null,
      loadingWorkflowTipo: false,
      loadingWorkflow: false,
      loadingUsuario: false,
    };
  },
  watch: {
    value: {
      immediate: false,
      handler(newValue) {
        if (newValue) {
          this.fetchDataFromWorkflow();
        }
      },
    },
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    isFormInvalid() {
      return !this.workflowtipoid || !this.dataForm.workflowid || !this.dataForm.funcionarioid;
    },
  },
  methods: {
    async validateForm() {
      const isValid = await this.$refs.refFormData.validate();
      if (isValid) {
        this.$emit('ok', this.dataForm);
        this.$bvModal.hide(this.idModal);
      }
    },
    async fetchDataFromWorkflow() {
      try {
        this.loadingWorkflow = true;
        const response = await axios.get(`/workflow/findByTipoWorkflow/${this.workflowtipoid}`);
        this.dataFromApiWorkflow = response.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      } finally {
        this.loadingWorkflow = false;
      }
    },
    async fetchDataFromWorkflowTipo() {
      try {
        this.loadingWorkflowTipo = true;
        const response = await axios.get('/workflow-tipo');
        this.dataFromApiWorkflowTipo = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      } finally {
        this.loadingWorkflowTipo = false;
      }
    },
    async resetform() {
      this.workflowtipoid = null;
    },
    async fetchDataFromUsuario() {
      try {
        this.loadingUsuario = true;
        const response = await axios.get('/usuarios/findAll?perPage=500000');
        this.dataFromApiUsuario = response.data.data.map((user) => ({
          value: user.usuarioid,
          label: user.usuario_nome,
        }));
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      } finally {
        this.loadingUsuario = false;
      }
    },
    onModalShow() {
      this.fetchDataFromWorkflowTipo();
      this.fetchDataFromUsuario();
      this.$refs.refFormData.reset();
    },
  },
};
</script>
